let count = 0;
let savedOverflow = '';

export function acquireScrollLock(): void {
  if (count === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  count += 1;
}

export function releaseScrollLock(): void {
  if (count === 0) return;
  count -= 1;
  if (count === 0) document.body.style.overflow = savedOverflow;
}

export function _resetScrollLockForTests(): void {
  if (count > 0) document.body.style.overflow = savedOverflow;
  count = 0;
  savedOverflow = '';
}
